export default __webpack_public_path__ + "static/media/menu.f80dc18a.png";